// libraries
import { get } from "@cloudspire/legacy-shared/src/libraries";

// helpers
import bookingEstimateHasTotal from "@cloudspire/legacy-resources/src/helpers/booking/estimate/hasTotal";

/**
 * Récupère le total de la réservation.
 */
const bookingEstimateGetTotal = ({ bookingEstimate, intl }) => {
  if (!bookingEstimateHasTotal({ bookingEstimate })) {
    return null;
  }

  const total = [];

  // Total séjour
  total.push({
    label: intl.formatMessage({
      defaultMessage: "Total séjour",
    }),
    value: intl.formatNumber(bookingEstimate.tripAmount, {
      style: "currency",
      currency: "EUR",
    }),
    bold: false,
  });

  const soldedAmount =
    get(bookingEstimate, "soldedAmount", 0) +
    get(
      bookingEstimate,
      "metas.ancvConnectAuthorizedTransactionStatus.amount",
      0
    );

  // Déjà réglé
  total.push({
    label: intl.formatMessage({
      defaultMessage: "Déjà réglé",
    }),
    value: intl.formatNumber(soldedAmount, {
      style: "currency",
      currency: "EUR",
    }),
    bold: false,
  });

  const balance =
    get(bookingEstimate, "balance", 0) -
    get(
      bookingEstimate,
      "metas.ancvConnectAuthorizedTransactionStatus.amount",
      0
    );

  // Solde restant dû
  total.push({
    label: intl.formatMessage({
      defaultMessage: "Solde restant dû",
    }),
    value: intl.formatNumber(balance, {
      style: "currency",
      currency: "EUR",
    }),
    bold: false,
  });

  const nextPaymentAmount =
    get(bookingEstimate, "metas.nextPayment.amount", 0) -
    get(
      bookingEstimate,
      "metas.ancvConnectAuthorizedTransactionStatus.amount",
      0
    );

  if (get(bookingEstimate, "metas.nextPayment.amount")) {
    // Votre prochain réglement
    total.push({
      label: intl.formatMessage({
        defaultMessage: "Votre prochain réglement",
      }),
      value: intl.formatNumber(nextPaymentAmount, {
        style: "currency",
        currency: "EUR",
      }),
      bold: true,
    });
  }

  return total;
};

export default bookingEstimateGetTotal;
